<template>
    <div id="companyManager" style="overflow: hidden; width: 100%; height:calc(100vh - 85px);">
        <div style="display: flex;width: 100%;">
            <vxe-form style="width: 60%" v-bind="formOptions">
            </vxe-form>
            <vxe-toolbar style="width: 40%" ref="toolbarRef" custom>
            </vxe-toolbar>
        </div>

        <vxe-table id="companyManagerData" :data="tableData" border :column-config="{ resizable: true }"
            class="table-style" :columns="columns" stripe width="100%" height="auto" :custom-config="customConfig"
            ref="tableRef">
            <vxe-column type="seq" width="50" align="center"></vxe-column>
            <vxe-column v-for="(column, index) in columns" :field="column.field" :title="column.title"
                align="center"></vxe-column>
            <vxe-column title="操作" width="250" align="center">
                <template #default="{ row }">
                    <vxe-button mode="text" status="success" icon="vxe-icon-edit"
                        @click="editEvent(row)">编辑</vxe-button>
                    <vxe-button mode="text" status="error" icon="vxe-icon-edit"
                        @click="deleteEvent(row)">删除</vxe-button>
                </template>
            </vxe-column>
        </vxe-table>

        <vxe-modal resize destroy-on-close show-footer show-confirm-button show-cancel-button v-model="showEditPopup"
            :title="selectRow ? '编辑' : '新增'" width="70vw" height="35vh" :loading="loading" :confirm-closable="false"
            @confirm="confirmEvent" @cancel="cancelEvent" @close="cancelEvent">
            <vxe-form ref="formRef" class="form-style" v-bind="formOptionsAdd"></vxe-form>
        </vxe-modal>

    </div>
</template>
<script>
import { VxeUI } from 'vxe-pc-ui'
import XEUtils from 'xe-utils'
import userProfile from '@/mixins/userProfile.js'
export default {
    name: 'companyManager',
    mixins: [userProfile],
    //组件创建
    created() {
        this.loadTableData();
    },
    mounrted() {
    },
    data() {
        const formOptions = {
            data: {
                companyName: '',
            },
            items: [
                { field: 'companyName', title: '企业名称', span: 8, itemRender: { name: 'VxeInput' } },
                
                // { field: 'quarter', title: '季度', span: 24, itemRender: { name: 'VxeDatePicker', props: { type: 'quarter' } } },
                // { field: 'companyName', title: '企业名称', span: 8, itemRender: { name: 'VxeInput' } },
                // { field: 'companyName', title: '企业名称', span: 8, itemRender: { name: 'VxeInput' } },
                // { field: 'companyName', title: '企业名称', span: 8, itemRender: { name: 'VxeInput' } },
                // { field: 'companyName', title: '企业名称', span: 8, itemRender: { name: 'VxeInput' } },
                {
                    span: 3,
                    // collapseNode: true,
                    align: 'center',
                    itemRender: {
                        name: 'VxeButtonGroup',
                        options: [
                            { type: 'submit', content: '搜索', status: 'primary', name: 'search' },
                            { type: 'reset', content: '重置', name: 'reset' },
                            { type: 'submit', content: '新增', status: 'success', name: 'add' }
                        ],
                        events: {
                            click: this.handleButtonClick // 调用 methods 中的方法
                        }
                    }
                }
            ]
        }
        const formOptionsAdd = {
            titleWidth: 80,
            titleAlign: 'right',
            titleColon: true,
            data: {
                id: '',
                companyName: '',
                hsCode: '',
                creditCode: '',
                shortName: '',
                contactName: ''
            },
            rules: {
                companyName: [
                    { required: true, message: '请输入名称' },
                ],
                hsCode: [
                    { required: true, message: '请选择海关编码' }
                ],
                creditCode: [
                    { required: true, message: '统一社会信用代码' }
                ],
                shortName: [
                    { required: true, message: '企业简称' }
                ],
                // contactName: [
                //     { required: true, message: '联系人' }
                // ]
            },
            items: [
                { field: 'companyName', title: '企业名称', span: 12, itemRender: { name: 'VxeInput' } },
                { field: 'hsCode', title: '海关编码', span: 12, itemRender: { name: 'VxeInput' } },
                { field: 'creditCode', title: '统一社会信用代码', span: 12, itemRender: { name: 'VxeInput' } },
                { field: 'shortName', title: '企业简称', span: 12, itemRender: { name: 'VxeInput' } },
                { field: 'contactName', title: '境外收发货人', span: 24, itemRender: { name: 'VxeInput' } },
                // {
                //     span: 3,
                //     // collapseNode: true,
                //     align: 'center',
                //     // itemRender: {
                //     //     name: 'VxeButtonGroup',
                //     //     options: [
                //     //         { type: 'submit', content: '搜索', status: 'primary' },
                //     //         { type: 'reset', content: '重置' }
                //     //     ]
                //     // }
                // }
            ]
        }
        return {
            tableData: [],
            columns: [],
            formOptions,
            formOptionsAdd,
            showEditPopup: false,
            loading: false,
            selectRow: undefined,
            isAddEdit: null,
        }
    },
    methods: {
        cancelEvent(){
            this.showEditPopup = false;
            this.formOptionsAdd.data.hsCode = '';
            this.formOptionsAdd.data.companyName = '';
            this.formOptionsAdd.data.creditCode = '';
            this.formOptionsAdd.data.shortName = '';
            this.formOptionsAdd.data.contactName = '';
            this.formOptionsAdd.data.id = '';
            
        },

        deleteEvent(row) {
            VxeUI.modal.confirm({
                id: 'myUniqueConfirm',
                title: '警告',
                content: '是否删除该条企业信息？',
                mask: false,
                lockView: false
            }).then(() => {
                // 用户点击了确认按钮，执行删除操作
                this.$api.deleteCompany( row.id ).then(res =>{
                    VxeUI.modal.message({ content: '删除成功', status: 'success' });
                    this.loadTableData();
                })
            }).catch(() => {
            });
        },
        handleButtonClick(options, button) {
            switch (button.name) {
                case 'search':
                    this.submitEvent();
                    break;
                case 'reset':
                    this.resetEvent();
                    break;
                case 'add':
                    this.addEvent();
                    break;
            }
        },
        addEvent() {
            this.selectRow = undefined
            this.isAddEdit = 1;
            // this.formOptionsAdd.data = XEUtils.clone(defaultData, true)
            this.showEditPopup = true
        },
        editEvent(row) {
            this.isAddEdit = 2;
            this.selectRow = row;
            this.formOptionsAdd.data = XEUtils.clone(row, true)
            this.showEditPopup = true
        },
        async confirmEvent() {
            const $form = this.$refs.formRef
            if ($form) {
                const errMap = await $form.validate()
                if (!errMap) {
                    this.showEditPopup = false
                    if (this.isAddEdit == 1) {
                        //   新增
                        delete this.formOptionsAdd.data.id;
                    }
                    this.$api.saveOrUpdateCompany( this.formOptionsAdd.data ).then(res =>{
                        VxeUI.modal.message({ content:  this.isAddEdit === 1 ? '新增成功':'编辑成功', status: 'success' })
                            this.loadTableData();
                            this.cancelEvent()
                    })
                }
            }
        },
        // 查询
        submitEvent(options) {
            this.$api.getCompanyList( { companyName : this.formOptions.data.companyName} ).then(res =>{
                this.columns = res.columns; // 动态列配置
                this.tableData = res.tableData; // 表格数据
            })
        },
        // 重置
        resetEvent() {
            this.formOptions.companyName = '';
        },
        // 加载表格数据和列配置
        loadTableData() {
            this.$api.getCompanyList( { companyName : ''} ).then(res =>{
                this.columns = res.columns; // 动态列配置
                this.tableData = res.tableData; // 表格数据
            })
        },
    }
}
</script>
<style lang="css" scoped>
::v-deep .table-style .vxe-table .vxe-cell {
    padding: 0 !important;
    line-height: 1.3vh;
}

::v-deep .el-form-item__label-wrap {
    margin-left: 0px !important;
}

::v-deep .table-style .vxe-body--column {
    padding: 0 !important;
}

::v-deep .form-style .vxe-form--item-title {
    width: 120px !important;
}
</style>